import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges class names with Tailwind CSS classes
 * @param {...string} inputs - Class names to merge
 * @returns {string} Merged class names
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * CSS variable reference
 * @param {string} variable - CSS variable name without '--' prefix
 * @returns {string} CSS variable reference
 */
export function cssVar(variable) {
  return `var(--${variable})`
}

/**
 * Helper to create container query class names
 * @param {('xs'|'sm'|'md'|'lg'|'xl')} breakpoint - Container breakpoint
 * @param {string} className - Class name to apply at breakpoint
 * @returns {string} Container query class name
 */
export function containerQuery(breakpoint, className) {
  return `@${breakpoint}:${className}`
}
